import styled from "styled-components";
import {CardRoot, CardTitle} from "account/components/AccountCards";

export const PlainCard = styled(CardRoot)`
	padding: 0;
	text-align: left;
`;
export const CardBody = styled.div<{$tagged: boolean}>`
	padding: 18px 20px;
	padding-inline-end: ${({$tagged}) => $tagged ? "calc(var(--peel-pin-width) + 18px)" : "20px"};
	@media (max-width: 720px) { padding-inline-end: 20px; }
`;
export const Title = styled(CardTitle)`
	display: flex; align-items: center; gap: 8px;
	svg { flex: none; color: ${({theme}) => theme.tokens.orange}; }
`;
export const Stats = styled.dl`
	display: grid; grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
	gap: 12px; margin: 12px 0;
`;
export const Stat = styled.div`
	display: flex; flex-direction: column; gap: 2px;
`;
export const StatValue = styled.dd`
	margin: 0; font-size: 22px; font-weight: 600;
	color: ${({theme}) => theme.tokens.ink};
`;
export const StatLabel = styled.dt`
	font-size: 12px; color: ${({theme}) => theme.tokens.ink2};
`;
export const Note = styled.p`
	margin: 0; font-size: 13px; line-height: 1.5;
	color: ${({theme}) => theme.tokens.ink2};
`;
